import moment from 'moment';
import { ParsedJourneyParams } from '@store/yourJourney/selectors';

export const buildDatesToCheck = (
  journeyParams: ParsedJourneyParams,
  dayNumber: number,
  dayNumberRange: number[] | undefined,
  isPackageRepeating: boolean
): string[] => {
  // For repeating packages, check ALL calendar days in the stay window, inclusive of checkout.
  if (isPackageRepeating) {
    const startDate = moment(journeyParams.fromDate).add(dayNumber, 'days');
    const endDate = moment(journeyParams.toDate);
    const days = endDate.diff(startDate, 'days') + 1;
    if (days <= 0) return [];
    if (dayNumberRange && dayNumberRange.length === 1) {
      if (dayNumberRange[0] === 0) {
        //exclude checkout day
        return Array.from({ length: days - 1 }, (_, i) =>
          startDate.clone().add(i, 'days').format('YYYY-MM-DD')
        );
      }
    }
    return Array.from({ length: days }, (_, i) =>
      startDate.clone().add(i, 'days').format('YYYY-MM-DD')
    );
  }

  if (dayNumberRange && dayNumberRange.length > 0) {
    return dayNumberRange.map((day) =>
      moment(journeyParams.fromDate).add(day, 'days').format('YYYY-MM-DD')
    );
  }

  return [moment(journeyParams.fromDate).add(dayNumber, 'days').format('YYYY-MM-DD')];
};
